import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProductDetailScreen from './components/ProductDetailScreen';
import './App.css';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<ProductDetailScreen />} />
        <Route path="/product" element={<ProductDetailScreen />} />
      </Routes>
    </div>
  );
}

export default App;
